window._theme = window._theme || {}; 


_theme.isMobile = jQuery(window).width() < 768 ? true : false;
_theme.isIpad = jQuery(window).width() < 1025 ? true : false;
_theme.isIpadAndUp = jQuery(window).width() > 767 ? true : false;
_theme.isLaptopAndUp = jQuery(window).width() > 1199.99 ? true : false;


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

_theme.focusTrap = function(elem, cb, tabbableAdditionalElems, enableBackwardJourney){
    // const isIos = document.documentElement.classList.contains('device--ios');
    let tabbableElems = ['select', 'input', 'textarea', 'button', 'a'];
    if(tabbableAdditionalElems){
      if(Array.isArray(tabbableAdditionalElems)) tabbableElems = tabbableElems.concat(tabbableAdditionalElems)
      if(typeof tabbableAdditionalElems === 'string') tabbableElems.push(tabbableAdditionalElems);
    }
    let tabbable = elem.find(tabbableElems.join(',')).filter(':visible');
    let firstTabbable = tabbable.first();
    let lastTabbable = tabbable.last();
    // console.log("reun",firstTabbable,"last",tabbable)
    firstTabbable.focus();
    // if(isIos) firstTabbable.dispatchEvent(new Event('touchstart'));
  
    lastTabbable.off('keydown').on('keydown', function(e) {
      if ((e.which === 9 && !e.shiftKey)) {
          e.preventDefault();
          firstTabbable.focus();
          // if(isIos) firstTabbable.dispatchEvent(new Event('touchstart'));
      }
    });
  
    firstTabbable.off('keydown').on('keydown', function(e) {
      if ((e.which === 9 && e.shiftKey && !enableBackwardJourney)) {
            e.preventDefault();
            lastTabbable.focus();
            // if(isIos) lastTabbable.dispatchEvent(new Event('touchstart'));
        }
    });
  
    elem.off('keydown').on('keydown', function(e) {
      if (e.keyCode === 27 ) {
        if(cb && typeof cb === 'function') {
          cb(elem)
        }
      }
    });
  }

  _theme.getOS = function() {
    if(!window.navigator) return '';
    var userAgent = window.navigator.userAgent;
    var userAgentData = window.navigator.userAgentData;
    var platform = userAgentData ? userAgentData.platform ? userAgentData.platform :  window.navigator.platform : window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;
  
    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'mac-os';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'ios';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'windows';
    } else if (/Android/.test(userAgent)) {
      os = 'android';
    } else if (/Linux/.test(platform)) {
      os = 'linux';
    }
  
    return os;
  }


  _theme.iPhoneVersion = function(){
    var iHeight = window.screen.height;
    var iWidth = window.screen.width;
  
    if (iWidth === 414 && iHeight === 896) {
      return "xmax-xr";
    } else if (iWidth === 375 && iHeight === 812) {
      return "x-xs";
    } else if (iWidth === 320 && iHeight === 480) {
      return "4";
    } else if (iWidth === 375 && iHeight === 667) {
      return "6";
    } else if (iWidth === 414 && iHeight === 736) {
      return "6-plus";
    } else if (iWidth === 320 && iHeight === 568) {
      return "5";
    } else if (iHeight <= 480) {
      return "2-3";
    }
    return 'none';
  } 


  _theme.focusMove=function(elem) {
    let tabbable = elem.find('select, input, textarea, button, a').filter(':visible');
    let firstTabbable = tabbable.first();
  
    firstTabbable.focus();
  }



  _theme.initHeaderEvetns = function(){
  
    $(document).on('click', '[data-trigger-menu]', handleSubmenuTrigger); 


    function handleSubmenuTrigger(evt){
        evt.preventDefault();
        // evt.stopPropagation();
        // evt.stopImmediatePropagation();
        if($(window).width() > 767){
          handleDesktopMegaMenu.call(this, evt);
        } else {
          handleMobileMegaMenu.call(this, evt);
        }
      }
    
      function handleDesktopMegaMenu(evt){
        const $self = $(this);
        const $parent = $(this).parent();
        $parent.toggleClass('active').siblings('li').removeClass('active');
        const attr = $(this).attr('aria-expanded') || false;
        const $submenu = $self.next('div');
        $(this).attr('aria-expanded', !JSON.parse(attr));
    
        setTimeout(() => {
          // _theme.focusTrap($submenu, function(){
          //   $parent.removeClass('active');
          //   $self.focus();
          //   $self.attr('aria-expanded', false);
          // }); 
    
          $submenu.off('keydown').on('keydown', function(evt){
            if(evt.key === 'Escape'){
              $parent.removeClass('active');
              $self.focus();
              $self.attr('aria-expanded', false);
            }
          });
    
          $submenu.off('focusout').on('focusout', function(evt){
            if(evt.relatedTarget && !$submenu[0].contains(evt.relatedTarget)){
              $parent.removeClass('active');
              $self.attr('aria-expanded', false);
            }
          });
        }, 250);
      }
    
        function handleMobileMegaMenu(evt){
            const $self = $(this);
            var expand = $(this).attr('aria-expanded') || false;
            expand = JSON.parse(expand);
            $(this).attr('aria-expanded', !expand);
            var $menu = $(this).next(".sub-menu-mobile");
            if($menu.length === 0) $menu = $(this).parent().find(".sub-menu-mobile").first();
            const isOpen = $menu.hasClass("sub-menu-open");
            if(isOpen){
            $menu.removeClass("sub-menu-open");
            $('.mb-area-mob').css({"overflow-y": "auto"});
            $menu.attr('aria-hidden','true');
            } else {
            $menu.addClass("sub-menu-open").css({overflow: ""});
            $('.mb-area-mob').css({overflow: "hidden"});
            $menu.attr('aria-hidden','false');  
            }
        
            $(this).animate({ scrollTop: 0}, 0);
            $(this).css({ overflow: "hidden" });
        
            if(_theme.isMobile) {
            $self.closest('.menu-lv-1').siblings().attr('aria-hidden','true');
            $self.closest('.sub-menu-mobile').find('.menu-col-banner').attr('aria-hidden','true');
            $self.closest('[data-griditem]').siblings().attr('aria-hidden','true'); 
        
            }
        
            setTimeout(function(){
            _theme.focusTrap($menu, function(){
                $menu.removeClass('sub-menu-open');
                $self.attr('aria-expanded', false);
                $self.focus();
            });
            }, 250);
        }
  
  }


  _theme.initAccessibleSwiperSlider = function (instance) {
    const focusAbleElm = ['select', 'input', 'textarea', 'button', 'a']
    instance.on('init',function() {
      let $slides=this.slides
      $slides.each(function() {
        if($(this).hasClass('swiper-slide-visible')) {
          $(this).attr('aria-hidden','false');
          $(this).find(focusAbleElm.join(',')).filter(':visible').attr('tabindex','0')
        }
        else {
          $(this).attr('aria-hidden','true');
          $(this).find(focusAbleElm.join(',')).filter(':visible').attr('tabindex','-1')
        }
      })
    })
    instance.on('slideChange',function() {
      let $slides=this.slides 
      setTimeout(function() {
        $slides.each(function() {
          if($(this).hasClass('swiper-slide-visible')) {
            $(this).attr('aria-hidden','false');
            $(this).find(focusAbleElm.join(',')).filter(':visible').attr('tabindex','0')
          }
          else {
            $(this).attr('aria-hidden','true');
            $(this).find(focusAbleElm.join(',')).filter(':visible').attr('tabindex','-1')
          }
        })
      },500); 
    })
    instance.init();
  }


  _theme.initAccessibleHroSlideShow = function(instance) {
    const focusAbleElm = ['select', 'input', 'textarea', 'button', 'a']
    instance.on('init',function() {
      let $slides=this.slides
      $slides.each(function() {
        if($(this).hasClass('swiper-slide-active')) {
          $(this).attr('aria-hidden','false');
          $(this).find(focusAbleElm.join(',')).filter(':visible').attr('tabindex','0')
        }
        else {
          $(this).attr('aria-hidden','true');
          $(this).find(focusAbleElm.join(',')).filter(':visible').attr('tabindex','-1')
        }
      })
    })
    instance.on('slideChange',function() {
      let $slides=this.slides
      setTimeout(()=> {
        $slides.each(function() {
          if($(this).hasClass('swiper-slide-active')) {
            $(this).attr('aria-hidden','false');
            $(this).find(focusAbleElm.join(',')).filter(':visible').attr('tabindex','0')
          }
          else {
            $(this).attr('aria-hidden','true');
            $(this).find(focusAbleElm.join(',')).filter(':visible').attr('tabindex','-1')
          }
        }) 
      },500); 
    })
    instance.init();
  }

  _theme.initSwiperPlayPause = function($parent, $sliderInstance, label){
    if($parent.length === 0 || $parent.find('.homepage-slider-play-pause').length === 0) return;
    if(!label) {
      label="Slider Autoplay play/pause";
    }
    
    $parent.find('.homepage-slider-play-pause').removeClass('hidden');
    const $playPausebutton = $parent.find('.homepage-slider-play-pause button');
    $playPausebutton.attr('aria-label','Stop '+label);  
    $playPausebutton.on('click', function(evt){
      jQuery(this).toggleClass('active');
      jQuery(this).attr('data-status','Pause')
      let msg = 'Autoplay started. press to pause';
      $sliderInstance.autoplay.start();  
      jQuery(this).attr('aria-label','Stop '+label);
      if(jQuery(this).hasClass('active')){
        jQuery(this).attr('data-status','Play')
        msg = 'Autoplay paused. press to play';
        $sliderInstance.autoplay.stop();
        jQuery(this).attr('aria-label','Start '+label);  
      }
    });
  }

  _theme.handleKeyboardUpDownButtonPress = function(evt){
    const key = evt.key.toUpperCase();
    if(key === 'ARROWUP'){
      const $prevElem = $(this).prev();
      if($prevElem.length) {
        $prevElem.addClass('selected').siblings().removeClass('selected');
        setTimeout(function(){
          $prevElem.focus();
        }, 250);
      }
    }
    
    if(key === 'ARROWDOWN'){
      const $nextElem = $(this).next();
      if($nextElem.length) {
        $nextElem.addClass('selected').siblings().removeClass('selected');
        setTimeout(function(){
          $nextElem.focus();
        }, 250);
      }
    }
  
    if(key === 'TAB' && !evt.shiftKey){
      const $nextElem = $(this).next();
      if($nextElem.length === 0) evt.preventDefault();
    }
  
    if(key === 'ENTER' || (key === ' ' && evt.which === 32)){
      evt.target.click();
    }
  }
   _theme.updateTitle = function(url,text) {
    if(window.location.href.includes(url)) {
      $('title').text(text)
    }
    }


    _theme.updateAccessibilityStatus = function(status){
      let $cartSrOnly = $('#cart-sr-only');
      if($cartSrOnly.length === 0) return;
      let msg = ''; // diff
      switch(status){
        case 'remove': msg = 'Please wait. removing item from cart'; break;
        case 'remove-success': msg = 'Item has been removed from the cart successfully'; break;
        case 'in-progress': msg = 'Please wait. updating cart'; break;
        case 'qty-plus': msg = 'Item increased by 1'; break;
        case 'qty-minus': msg = 'Item decreased by 1'; break;
        case 'success': msg = 'Cart updated successfully'; break;
        case 'error': msg = 'Something went wrong while updating cart'; break;
        case 'empty': msg = 'removed. there are no items in your cart.'; break;
        case 'ATC-success': msg = 'Item added to your cart successfully.'; break; 
        default: msg = '';
      }
      $cartSrOnly.text(msg)
    }
    
  $(function () {
    _theme.initHeaderEvetns();
    const htmlSelector=document.querySelector('html')

    if(htmlSelector) {
      var browserZoomLevel = Math.round(window.outerWidth / window.innerWidth * 100) + 1;
      console.log(browserZoomLevel,"show broswer level zoom ")
      
          if (browserZoomLevel >= 200 && browserZoomLevel < 400 ) {
              htmlSelector.classList.add('mode--zoom')
              htmlSelector.classList.add('zl-200')
              htmlSelector.classList.remove('zl-400')
          }
          else if (browserZoomLevel >= 400) {
              htmlSelector.classList.remove('zl-200')
              
              htmlSelector.classList.add('zl-400')
              htmlSelector.classList.add('mode--zoom')
          }
          else {
              htmlSelector.classList.remove('mode--zoom');
              htmlSelector.classList.remove('zl-400');
              htmlSelector.classList.remove('zl-200');
          }
    }
  function initDeviceVaries(){
    console.log('in it zoom fires... ')
    const htmlSelector = document.querySelector('html');
    Array.from(htmlSelector.classList).map(function (cls) {
        if (cls.indexOf('device--') > -1) htmlSelector.classList.remove(cls);
    });
  
    var browserZoomLevel = Math.round(window.outerWidth / window.innerWidth * 100) + 5;
    
        if (browserZoomLevel >= 200 && browserZoomLevel < 400 ) {
            htmlSelector.classList.add('mode--zoom')
            htmlSelector.classList.add('zl-200')
            htmlSelector.classList.remove('zl-400')
        }
        else if (browserZoomLevel >= 400) {
            htmlSelector.classList.remove('zl-200')
            htmlSelector.classList.add('zl-400')
        }
        else {
            htmlSelector.classList.remove('mode--zoom');
            htmlSelector.classList.remove('zl-400')
            htmlSelector.classList.remove('zl-200')
        }
    
    if (window.screen.availWidth > 767) htmlSelector.classList.add('device--ipadandup');
    else htmlSelector.classList.add('device--mobile');
  }

  window.addEventListener('resize', initDeviceVaries)

  })


 // Check if the focused element has the specific class name


// Function to check the style and modify the background color
function checkAndStyleModal() {
  // Select all elements with the class 'mc-modal'
  const modals = document.querySelectorAll('.mc-modal');

  // Loop through each element and check its display style
  modals.forEach(modal => {
    const style = window.getComputedStyle(modal);
    if (style.display === 'block') {
      // If display is block, set the background color to red
      modal.style.backgroundColor = 'red';
    }
  });
}

// Create a MutationObserver instance
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    // Check if any added nodes contain an element with 'mc-modal'
    if (mutation.addedNodes.length) {
      checkAndStyleModal();
    }
  });
});

// Start observing the document body for childList changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Initial check in case the modal is already present
checkAndStyleModal();

